module.exports = __webpack_public_path__ + "static/media/filter-down-arrow.d170c029.svg";